import 'css-chunksrc/client/scenes/list/timestamp/styles.scss';export default {
  "timestamp": "_timestamp_1o7pw_1",
  "dates": "_dates_1o7pw_6",
  "row": "_row_1o7pw_10",
  "date": "_date_1o7pw_6"
};